<!-- @veltra/icons generated sha256:562cfd94cb7f1b3e gen:8 source:src/svg/normal/enter.svg -->
<script setup lang="ts">
defineOptions({ name: 'Enter' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M13 4.493V10H4.207l1.291-1.29a.49.49 0 0 0 .013-.7l-.008-.007a.51.51 0 0 0-.714 0l-2.139 2.14a.51.51 0 0 0 0 .714l2.14 2.14a.49.49 0 0 0 .707.006.506.506 0 0 0 .001-.712L4.208 11H13a1 1 0 0 0 1-1V4.493A.5.5 0 0 0 13.496 4a.496.496 0 0 0-.496.493"
    />
  </svg>
</template>
